export const UNSUPPORTED_LINK_PROPS = ["staticContext", "tReady"];
